import Blocker from "@/components/blocker";
import type { AnyReactFormApi } from "@/types/form";

type FormBlockerProps = {
  Subscribe: AnyReactFormApi["Subscribe"];
};

export const FormBlocker = ({ Subscribe }: FormBlockerProps) => (
  <Subscribe>
    {({ isDirty, isSubmitting }) => (
      <Blocker blocked={isDirty || isSubmitting} />
    )}
  </Subscribe>
);
